<template>
    <tr class="session__register_print_table_item">
        <td class="session__register_print_table_item_name">
            <span>{{ item.firstName }} {{ item.lastName }}</span>
        </td>
        <template v-if="routeQueryIncludeEmailInPrint">
            <td class="session__register_print_table_item_email">
                <span>{{ item.email }}</span>
            </td>
        </template>
        <td :class="['session__register_print_table_item_attendance', { 'session__register_print_table_item_attendance--wide' : absenceReason }]">
            <template v-if="attendance !== '' && attendance !== null && attendance !== undefined">
                {{ attendance === true ? 'Present' : 'Absent' }}
            </template>
        </td>
        <template v-if="routeQueryAdditionalColumn">
            <td class="session__register_print_table_item_additional"></td>
        </template>
    </tr>
</template>

<script>

export default {
  components: {},
  name: 'session-register-table-item',
  props: {
    index: {
      type: [String, Number],
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    sessionAbsenceReasonRequired: function () {
      return this.$store.getters.getSessionCompletionAbsenceReasonRequired
    },
    //
    attendance: {
      get () {
        return this.item.attendance
      }
    },
    absenceReason: {
      get () {
        return this.item.absenceReason
      }
    },
    absenceReasonValid: {
      get () {
        return this.item.absenceReasonValid
      }
    },
    routeQuery () {
      return this.$route.query
    },
    routeQueryIncludeEmailInPrint () {
      return this.routeQuery.includeEmailInPrint
    },
    routeQueryAdditionalColumn () {
      return this.routeQuery.includeAdditionalColumnInPrint
    },
    routeQueryAdditionalColumnName () {
      return this.routeQuery.additionalColumnName
    }
  },
  inject: ['$validator']
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/sessions/sessionregistertableitem";
</style>
